import React from "react";
import { Link } from "react-router-dom";

// Images
import TeacherImg from "../../../asset/images/home/female teacher crossed arms.png";

const ListenToTeacher = () => {
    const vowels = [
        { letter: "a", bg: "#1A588B" },
        { letter: "e", bg: "#D5B641" },
        { letter: "i", bg: "#439D55" },
        { letter: "o", bg: "#E14942" },
        { letter: "u", bg: "#374957" },
    ];

    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 2: Vowel Sounds (Long & Short)
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Checkpoint
                </h3>

                {/* Start Listening Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8 flex items-center justify-center">
                        Press start to start listening to the instructor
                    </button>
                </div>

                {/* Engage Section */}
                <section className="py-10">
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-white border-2 border-primary rounded-xl pt-10 shadow-lg">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                                {/* Left Image */}
                                <div className="flex justify-center">
                                    <img
                                        src={TeacherImg}
                                        alt="Virtual Teacher"
                                        className="max-w-full h-auto rounded-lg" height="50%" width="50%"
                                    />
                                </div>

                                {/* Right Content */}
                                <div className="p-3 text-center">
                                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 leading-tight">
                                        Get ready to listen & Answer
                                    </h2>
                                    <p className="text-xl text-muted leading-relaxed">
                                        Click on the corresponding vowel
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Vowel Buttons */}
                <div className="text-center">
                    <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">
                        {vowels.map((vowel, idx) => (
                            <div key={idx}>
                                <button
                                    className="letter-btn text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20
                    rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl opacity-50"
                                    style={{ backgroundColor: vowel.bg }}
                                >
                                    {vowel.letter}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Navigation Button */}
                <div className="flex justify-center mt-5">
                    <Link to="/dashboard/modules/listen-to-teacher-correct">
                        <button className="px-8 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Start
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
};

export default ListenToTeacher;
